import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {Observable} from 'rxjs';
import {SharedApiService} from '../../shared/services/api.service';
import {Article} from "../models/article.model";

@Injectable()
export class ArticleResolver implements Resolve<Article> {
    constructor(private apiService: SharedApiService) {
    }

    public resolve(route: ActivatedRouteSnapshot): Observable<Article> {
        return this.apiService.getArticle(route.params.id);
    }
}
